<style>
    table thead th input {
        @apply w-full;
    }

    #notaSimulada td {
        @apply border border-blue-700;
    }
    .input-precio > div {
        @apply flex px-2 align-middle bg-gray-100 border rounded-l;
    }
    .input-precio input {
        @apply w-24 text-right border-l-0 rounded-l-none;
    }
    .eliminar i {
        @apply my-auto mr-2 text-red-700 cursor-pointer;
    }
</style>

<script>
    import { tick, onMount, onDestroy } from 'svelte';
    import { fly } from 'svelte/transition';
    import { goto } from '@sveltech/routify';
    import Calendar from 'svelte-calendar';

    import { productos, traerProductos } from '../productos/_productos.svelte';
    import {
        comoMoneda,
        buildSearch,
        keydowns,
        sumProp,
        clearOnEscape,
    } from '../../utils';
    import api from '../../api';
    import SelectFirst from '../../components/select-first.svelte';
    import MonedaInput from '../../components/moneda-input.svelte';

    import {
        datosVenta,
        tipo,
        cantidadPorProducto,
        precioPorProducto,
        resetearVenta,
        TIPOS,
    } from './_store.svelte';

    $: productosVenta = Object.entries($cantidadPorProducto)
        .filter(([, cantidad]) => cantidad)
        .map(([slug, cantidad]) => ({
            slug,
            cantidad,
            precio: $precioPorProducto[slug] || undefined,
        }));

    $: productosVenta.length && simularVenta();
    $: $tipo, simularVenta();

    async function simularVenta() {
        const response = await api.post('ventas/simular/', {
            ventas_producto: productosVenta,
            tipo: $tipo,
        });
        notaSimulada = { ...response.data };
    }

    async function guardarVenta() {
        const {
            data: { id },
        } = await api.post('ventas/', {
            ventas_producto: productosVenta,
            cliente: $datosVenta.cliente,
            fecha: isoDate,
            tipo: $tipo,
        });
        await $goto(`../${id}/`);
        resetearVenta();
    }

    let filtroNombre = '';
    let cantidad = '';
    let inputCantidad;
    $: isoDate =
        $datosVenta.fecha && $datosVenta.fecha.toISOString().slice(0, 10);
    $: formattedDate =
        isoDate &&
        `${isoDate.slice(8, 10)}-${isoDate.slice(5, 7)}-${isoDate.slice(0, 4)}`;

    let notaSimulada = { ventas_producto: [], num_venta: null };

    $: numCantidad = parseInt(cantidad || '0');

    function productoEscogido({ detail: { slug: slugProducto } }) {
        $cantidadPorProducto[slugProducto] = numCantidad;
        inputCantidad.focus();
        cantidad = '';
        filtroNombre = '';
    }

    $: ventaValida = Boolean(
        $datosVenta.cliente && $datosVenta.fecha && productosVenta.length
    );
    onDestroy(traerProductos);
</script>

<div class="flex items-center mt-3">
    <div class="p-3 pt-0 ml-auto mr-12 border rounded">
        <h5>Datos</h5>
        <Calendar
            bind:selected="{$datosVenta.fecha}"
            format="{'#{d}-#{m}-#{Y}'}"
        />
        <div class="my-3">
            <input
                required
                placeholder="Cliente"
                bind:value="{$datosVenta.cliente}"
            />
        </div>
        <div class="group">
            {#each Object.values(TIPOS) as tipo_}
                <button
                    on:click="{() => ($tipo = tipo_)}"
                    class:active="{$tipo === tipo_}"
                    class="capitalize"
                >
                    {tipo_}
                </button>
            {/each}
        </div>
        <h5>Inventario</h5>
        <table class="border">
            <thead>
                <tr>
                    <th class="text-right">En Existencia</th>
                    <th>Producto</th>
                    <th class="text-right">Faltante</th>
                </tr>
            </thead>
            <tbody>
                {#each notaSimulada.ventas_producto as { nombre, faltan, en_existencia }}
                    <tr transition:fly="{{ x: 10 }}">
                        <td class="text-right">{en_existencia}</td>
                        <td>{nombre}</td>
                        <td class="text-right" class:text-red-700="{faltan}">
                            {faltan}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
        <button
            class="mt-3"
            disabled="{!ventaValida}"
            on:click="{guardarVenta}"
        >
            Guardar Venta
        </button>
    </div>
    <div class="mr-auto" id="notaSimulada">
        <div class="flex pb-2 mb-6 border-b-2 border-red-700">
            <img
                class="object-contain h-20 mt-auto"
                src="../swipe_logo.jpg"
                alt=""
            />
            <div class="flex-1 mx-12 text-center">
                <div class="-my-4 text-6xl text-blue-800 font-italianno">
                    Carmen Jaime
                </div>
                <div class="font-bold text-red-700">Distribuidora Oficial</div>
            </div>
            <div class="flex flex-col">
                <div class="mb-auto ml-auto">
                    {notaSimulada.num_venta || '-'}
                </div>
                <div class="flex">
                    <img
                        class="object-contain h-6"
                        src="../whatsapp.png"
                        alt=""
                    />
                    <div class="ml-2 font-bold">3334408597</div>
                </div>
            </div>
        </div>

        <div class="flex mb-6">
            <div class="mr-2 font-bold">Nombre del cliente:</div>
            {$datosVenta.cliente}
            <div class="ml-auto">{formattedDate}</div>
        </div>

        <table class="w-full border">
            <thead>
                <tr>
                    <td>Cantidad</td>
                    <td>Producto</td>
                    <td>Precio Unitario</td>
                    <td>Subtotal</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <input
                            class="w-20 text-right"
                            bind:value="{cantidad}"
                            bind:this="{inputCantidad}"
                            type="number"
                            min="1"
                        />
                    </td>
                    <td>
                        <SelectFirst
                            options="{$productos.map(producto => ({
                                ...producto,
                                cls: producto.ha_sido_comprado
                                    ? 'bg-green-100'
                                    : '',
                            }))}"
                            bind:filter="{filtroNombre}"
                            on:selected="{productoEscogido}"
                        />
                    </td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                </tr>
                {#each notaSimulada.ventas_producto as { nombre, slug, cantidad, precio, subtotal } (slug)}
                    <tr transition:fly="{{ x: 10 }}">
                        <td>
                            <div class="flex">
                                <i
                                    class="mr-auto text-red-700 cursor-pointer material-icons"
                                    on:click="{() => ($cantidadPorProducto[slug] = 0)}"
                                >
                                    clear
                                </i>
                                <div>{cantidad}</div>
                            </div>
                        </td>
                        <td>{nombre}</td>
                        <td>
                            <MonedaInput>
                                <input
                                    use:keydowns
                                    on:keydown.Enter="{({ target: { value } }) => ($precioPorProducto[slug] = value)}"
                                    type="number"
                                    value="{precio}"
                                />
                            </MonedaInput>
                        </td>
                        <td class="text-right">{comoMoneda(subtotal)}</td>
                    </tr>
                {/each}
            </tbody>
            <tfoot>
                <tr class="text-lg font-bold">
                    <td class="text-right">
                        {sumProp(notaSimulada.ventas_producto, 'cantidad')}
                    </td>
                    <td colspan="2">Total</td>
                    <td class="text-right">
                        {comoMoneda(sumProp(notaSimulada.ventas_producto, 'subtotal'))}
                    </td>
                </tr>
            </tfoot>
        </table>
        <div class="mt-3 text-4xl font-bold text-blue-800 font-italianno">
            Muchas gracias por tu compra y por recomendarnos!
        </div>
    </div>
</div>
